import { useQuery } from '@tanstack/vue-query'
import { createSharedComposable } from '@vueuse/core'
import { computed } from 'vue'

import { getWorkload } from '@/api/workload'

interface WorkloadItem {
  sla_days: number
  valuation_request_ref: string
  valuer?: {
    username: string
  }
  customer?: string
}

export const useWorkload = createSharedComposable(() => {
  const query = useQuery<WorkloadItem[]>({
    queryKey: ['workload'],
    queryFn: async () => await getWorkload().then((res) => res.data),
  })

  const data = computed(() => query.data.value)

  const isLoading = computed(() => query.isPending.value)

  return {
    data,
    isLoading,
  }
})
